/**
 * What the lead form's submit button should say and do, given where the
 * submission is. Pure so the states are testable without a browser.
 */
export const SUBMIT_STATUS = { idle: 'idle', submitting: 'submitting', error: 'error' } as const;
export type SubmitStatus = (typeof SUBMIT_STATUS)[keyof typeof SUBMIT_STATUS];

const SENDING_LABEL = 'Sending…';

export interface SubmitButtonState {
  readonly label: string;
  readonly disabled: boolean;
}

export function submitButtonState(input: {
  status: SubmitStatus;
  submitLabel: string;
}): SubmitButtonState {
  if (input.status === SUBMIT_STATUS.submitting) return { label: SENDING_LABEL, disabled: true };
  return { label: input.submitLabel, disabled: false };
}
